import { Dictionary, getSearchParams } from '@tmap-web-lib/utils';
import isEmpty from 'lodash/isEmpty';
import { PropsWithChildren, createContext, useMemo } from 'react';

import { PageIdContext, PageIdExtra, PageIdSearchParams } from './types';

type Props = PropsWithChildren<{}>;

const Context = createContext({} as PageIdContext);

function createPageIdContext() {
  const url = new URL(window.location.href);
  const searchParams = getSearchParams<PageIdSearchParams>();
  const { pageid, extra, service } = searchParams;
  const defaultExtra = isEmpty(extra)
    ? JSON.stringify({ logbox: { type: 'tab', origin: 'tab' } })
    : extra && decodeURIComponent(extra);
  let extraObject: PageIdExtra & Dictionary<string | number | boolean | undefined>;

  try {
    extraObject = JSON.parse(defaultExtra as string);
  } catch {
    extraObject = {};
  }

  return {
    service,
    pageid,
    extra,
    extraObject: extraObject,
    searchParams,
    searchParamsString: url.search.replace(/^\?/, ''),
  };
}

function PageIdContextProvider(props: Props) {
  const { children } = props;
  const pageIdContext = useMemo(() => createPageIdContext(), []);

  return (
    <Context.Provider value={pageIdContext}>
      <>{children}</>
    </Context.Provider>
  );
}

export { PageIdContextProvider, Context, createPageIdContext };
